export default "__VITE_ASSET__rYfR0y55iGUMn8XdAn2pTg__";